module.exports = __webpack_public_path__ + "static/media/empty-box.53c7ed88.svg";